import CloseIcon from '@mui/icons-material/Close';
import { Chip } from '@mui/material';

interface OwnerTableHeaderChipProps {
  label: string;
  onDelete: () => void;
}

const OwnersTableHeaderChip = (props: OwnerTableHeaderChipProps) => {
  return (
    <Chip
      label={props.label}
      onDelete={props.onDelete}
      sx={{
        border: '2px #39A2DB solid',
        bgcolor: '#ffffff',
        color: '#39A2DB',
        height: '38px',
        fontSize: '16px',
        borderRadius: '24px',
        marginRight: '10px',
        marginBottom: '6px',
      }}
      deleteIcon={<CloseIcon sx={{ color: '#39A2DB !important' }} />}
    />
  );
};

export default OwnersTableHeaderChip;
